import { createStyles } from "@mantine/core";
import { SEGMENT_STATUS_COLORS } from "../constants/segmentConstants";

const SegmentStatusBadgeStyles = createStyles(() => ({
  label: {
    padding: "6px 12px",
    borderRadius: "32px",
    fontSize: "11px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "11px",
    letterSpacing: "0.16px",
    textAlign: "left",
    textTransform: "capitalize",
    border: "none",
  },
  active: {
    backgroundColor: SEGMENT_STATUS_COLORS.activeBackground,
    color: SEGMENT_STATUS_COLORS.activeText,
  },
  inactive: {
    backgroundColor: SEGMENT_STATUS_COLORS.inactiveBackground,
    color: SEGMENT_STATUS_COLORS.inactiveText,
  },
}));

export default SegmentStatusBadgeStyles;
